export const environment = {
  production: false,
  url: 'https://function-portalhistorico-dev.azurewebsites.net/api',
  apptoken: 'EWUKQbUiQU28WWSAS9YN'
};
